import React from 'react';
import './value.css';

const Value = () => {
    return (
        <>

            <div className="values-content" data-aos="fade-up">
                <div className="values">
                    <div className="values-container">
                        <div className="value-content-title">

                            <h2> Our Core Values</h2>
                            <span>At Rooba Swastha Pharmaceuticals, our work is guided by our core values, which reflect our deep commitment to our customers and partners.</span>

                        </div>



                        <div className="content-text">

                            <div className="text-item row1">
                                <h3>Quality</h3>
                                <p>Our dedication to quality excellence means we adhere to the highest standards.</p>
                            </div>
                            <div className="text-item row2">
                                <h3>Affordability</h3>
                                <p>We believe that affordability is key, ensuring our medicines are accessible to everyone and making quality healthcare affordable for all.</p>
                            </div>
                            <div className="text-item row3">
                                <h3>Integrity</h3>
                                <p>We operate with unwavering integrity and a strong sense of social responsibility, putting patient well-being at the heart of every decision.</p>
                            </div>
                            <div className="text-item row4">
                                <h3>Innovation</h3>
                                <p>Through innovation and collaboration, we strive to shape the future of generic medicines and expand access to care.</p>
                            </div>



                        </div>

                    </div>
                </div>
            </div>



        </>
    );
}

export default Value;
